import React ,{useEffect}from 'react'
import { useParams } from 'react-router-dom'
import styles from './StateHeader.module.scss'
import Content from '../../../components/Content'
import Layout from '../../../components/Layout'
import GeoProvider from '../../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from './../dataDisplayOptions'
import { startDate, endDate, displayDate } from './../dates'
import Header from './Header'
import Gender from '../../GenderAge'
import SeasonalPattern from '../../SeasonalPattern'
import SystemNotification from './../../Dashboard/SystemNotification'
import BelowMapNotification from '../../Dashboard/BelowMapNotification'
const FluStateDashboard = () => {
  const { area, loc } = useParams()
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'state'}
            >
              <SystemNotification/>
              <Header headerType={area} headerNumber={2} geo_id={loc} />
              <DashboardMap
                geo_type={area}
                geo_parent={loc}
                zoomLocation={loc}
              />
              <BelowMapNotification message_type='WEEKLY'/>
              <Gender geo_type={area} geo_id={loc} data_type="flu"/>
              <SeasonalPattern geo_type={area} geo_id={loc} data_type="flu"/>
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default FluStateDashboard
